// Hover Intent
// import './custom/hoverintent';

// Smooth Scroll
import './custom/smoothscroll';

// Woocommerce
import './custom/woocommerce';

// Alpine
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
Alpine.plugin(collapse);
window.Alpine = Alpine.start();

// Vidstack
import { PlyrLayout, VidstackPlayer } from 'vidstack/global/player';

const initializePlayers = async () => {
    const players = document.querySelectorAll('.player');

    for (const el of players) {
        const { src, title, poster } = el.dataset;

        // Skip if no source is provided
        if (!src) continue;

        try {
            await VidstackPlayer.create({
                layout: new PlyrLayout(),
                target: el,
                src,
                poster
            });

            console.log(`Player initialized for ${title || 'Unknown'}`);
        } catch (error) {
            console.error(`Failed to initialize player for ${title || 'Unknown'}:`, error);
        }
    }
};

// Ensure the script runs only when DOM is ready
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializePlayers);
} else {
    initializePlayers();
}

// Swiper
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade, Mousewheel, A11y } from 'swiper/modules';
Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Mousewheel, A11y]);

// Gallery slider
const gallerySlider = new Swiper('.gallery-slider', {
    loop: false,
    centerInsufficientSlides: false,
    spaceBetween: 32,
    breakpoints: {
        0: {
            slidesPerView: 1.5,
        },
        768: {
            slidesPerView: 2,
        },
    },
    mousewheel: {
        enabled: true,
        forceToAxis: false,
        releaseOnEdges: true,
    },
    navigation: {
        nextEl: ".gallery-nav.next",
        prevEl: ".gallery-nav.prev",
    },
});

// Network slider
const logoSlider = new Swiper('.network-slider', {
    spaceBetween: 24,
    loop: true,
    centerInsufficientSlides: true,
    breakpoints: {
        0: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
        1280: {
            slidesPerView: 5,
        }
    },
    autoplay: true,
    mousewheel: {
        enabled: true,
        forceToAxis: true,
    }
});

// Network slider
const coursesSlider = new Swiper('.courses-slider', {
    spaceBetween: 48,
    loop: true,
    centerInsufficientSlides: true,
    breakpoints: {
        0: {
            slidesPerView: 1,
            slidesPerGroup: 1,
        },
        640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
        },
        1024: {
            slidesPerView: 3,
            slidesPerGroup: 3,
        }
    },
    mousewheel: {
        enabled: true,
        forceToAxis: true,
    },
    pagination: {
        el: ".courses-pagination",
        clickable: true,
    },
});

// Mixitup
import mixitup from 'mixitup';
import mixitupMultifilter from 'mixitup-multifilter';
mixitup.use(mixitupMultifilter);

// Grid and messages selectors
const grid = document.querySelector('.sortable-grid');
const messages = document.querySelector(".sortable-messages");

if (grid) {
    const mixer = mixitup(grid, {
        multifilter: {
            enable: true
        },
        selectors: {
            target: '.sortable-item'
        },
        animation: {
            effects: 'fade',
            easing: 'ease-in-out'
        },
        callbacks: {
            onMixStart: (state) => {
                // Optional: Add loading state handling
            },
            onMixEnd: (state) => {
                const { totalShow } = state;

                if (totalShow === 1) {
                    messages.innerHTML = `${totalShow} ${single}`;
                } else if (totalShow > 1) {
                    messages.innerHTML = `${totalShow} ${multi}`;
                } else {
                    messages.innerHTML = error;
                }
            }
        }
    });

    mixer.show().then((state) => {
        // Optional: Handle successful initialization
        console.log('Mixer initialized successfully');
    }).catch((error) => {
        console.error('Failed to initialize mixer:', error);
    });
}

// Credits

// Decompress ASCII
const decompressASCII = (art) => {
    const decompressed = art.replace(/(\d+)/g, (match, number) => ' '.repeat(parseInt(number, 10)));
    const formatted = decompressed
        .replace(/\\n\\r/g, '\n')
        .replace(/\\n/g, '\n')
        .replace(/\\r/g, '');

    console.log(formatted);
};

document.addEventListener("DOMContentLoaded", () => {
    const art = "****97\n\r****22****71\n\r****22****71\n\r****97\n\r****97\n\r****4******12****6****************9*********15**********6\n\r******************8****5*****************6***************9****************3\n\r********6*****7****16*****5*****9*****5*****10***** \n\r*****11*****5****14*****6*****11*****3****13****1\n\r****13****5****13*****7*********************3****14****\n\r****13****5****11*****9****20****14****\n\r****13****5****10****11****20****14****\n\r1*****9*****6****8*****13****11****4****14****\n\r3****************7****6***************6******6*****5****14****\n\r6**********10****5*****************7*************7****14****\n\r";

    console.log('A DIGITAL PROJECT BY');
    decompressASCII(art);
});